import { useState, useEffect } from 'react';
import { APIDeleteAccessCredentials, APIPostAccessCredentials } from '../../api/access/Access';
import { FaRegCopy } from "react-icons/fa";

export const CredentialsShare = ({accessData, setAccessData, entityId, entityType}) => {
    const [ id, setId ] = useState(null);
    const [ accessId, setAccessId ] = useState(null);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const generatePassword = (length = 25) => {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    }

    const generateCredentials = async () => {
        const newUsername = `user_${Math.random().toString(36).substring(2, 14)}`;
        const newPassword = generatePassword();
        const accessCredentials  = await APIPostAccessCredentials(entityId, entityType, newUsername, newPassword);
        if (accessCredentials) {
            setAccessData(accessCredentials);
        }
    };

    const deleteCredentials = async () => {
        await APIDeleteAccessCredentials(id)
        setAccessData(null);
        setId(null);
        setAccessId(null);
    }

    useEffect(() => {
        if (accessData && accessData.id && accessData.access_id) {
            setId(accessData.id);
            setAccessId(accessData.access_id);
            setUsername(accessData.username);
            setPassword(accessData.password);
        } else {
            setId(null);
            setAccessId(null);
        }
    }, [accessData]);


    return (
        <div className="flex flex-col gap-4">
            {id ? (
                <>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Link zu Ihrem Plan</h2>
                    <p className="text-gray-600 text-sm leading-relaxed mb-2">
                        Hier ist der Link zu Ihrem Plan. Zum Zugriff werden die unten stehenden Zugangsdaten benötigt.
                    </p>
                    <div className="flex flex-col gap-1 mb-2">
                        <div className="mb-1 items-center flex">
                            <div className="block text-sm font-medium w-[120px] ">Benutzername:</div>
                            <div className="text-gray-900/60  sm:text-sm ">
                                {username}
                            </div>
                        </div>
                        <div className="mb-4 items-center flex">
                            <div className="block text-sm font-medium w-[120px] ">Passwort:</div>
                            <div className="text-gray-900/60  sm:text-sm ">
                                {password}
                            </div>
                        </div>
                        <button
                            type="button"
                            className="bg-gray-600 text-white rounded-md px-4 py-2 text-sm font-semibold mt-2"
                            onClick={() => {
                                navigator.clipboard.writeText(`Benutzername: ${username}\nPasswort: ${password}`);
                            }}
                        >
                            Zugangsdaten kopieren <FaRegCopy className="inline-block ml-1" />
                        </button>
                    </div>
                    <div className="flex items-center gap-2 mb-2">
                        <input
                            type="text"
                            value={`https://app.xplanung24.de/share/${accessId}`}
                            readOnly
                            className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700"
                        />
                        <button
                            type="button"
                            className="bg-gray-600 text-white rounded-md px-4 py-2 text-sm font-semibold"
                            onClick={() => navigator.clipboard.writeText(`https://app.xplanung24.de/share/${accessId}`)}
                        >
                            <FaRegCopy className="inline-block" />
                        </button>
                    </div>
                    <p className="text-gray-500 text-sm mt-2">
                        Hinweis: Der Link bleibt aktiv, bis Sie ihn löschen. Zum Zugriff werden die oben stehenden Zugangsdaten benötigt.
                    </p>
                    <button
                        type="button"
                        className="self-end w-40 text-center truncate items-center rounded-md bg-red/80 border-2 px-2 py-2 text-sm font-semibold text-white"
                        onClick={deleteCredentials}
                    >
                        Zugang löschen
                    </button>
                </>
            ) : (
                <>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Plan via Link & Zugangsdaten teilen</h2>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                        Erzeugen Sie Zugangsdaten und einen Link, um Ihren privaten Plan geschützt zu teilen. Nur wer Link und Zugangsdaten besitzt, kann den Plan einsehen.
                        <span className="block mt-2 text-gray-500 italic">
                            Hinweis: Der Plan bleibt privat, solange Sie keinen Link erstellen oder weitergeben. Wenn Sie den Link später löschen, ist der Plan darüber nicht mehr aufrufbar.
                        </span>
                    </p>
                    <button
                        type="button"
                        className="self-end w-54 text-center truncate items-center rounded-md bg-white border-gray-600 border-2 px-2 py-2 text-sm font-semibold text-gray-600 mb-2"
                        onClick={generateCredentials}
                    >
                        Zugangsdaten generieren
                    </button>
                </>
            )}
        </div>
    );
}
